import { convertToMessageDescriptors } from "@Utils/intl"
import rawStrings from "./strings.json"

const strings = convertToMessageDescriptors(rawStrings)

export default strings
